import { render, staticRenderFns } from "./RegistrationPage.vue?vue&type=template&id=11f95050&scoped=true"
import script from "./RegistrationPage.vue?vue&type=script&lang=js"
export * from "./RegistrationPage.vue?vue&type=script&lang=js"
import style0 from "./RegistrationPage.vue?vue&type=style&index=0&id=11f95050&prod&lang=css"
import style1 from "./RegistrationPage.vue?vue&type=style&index=1&id=11f95050&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11f95050",
  null
  
)

export default component.exports